import React, { useState } from "react";
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  IconButton,
  Paper,

} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import JournalEntry from "../Components/JournalEntry";





const InvoiceJournalEntryModal = ({ open, setOpen,
  journalEntry,
  totCdtAmt,
  totDbtAmt,
  Type,
  invTransArr,
  paymentTransArr,
  partyType,
  registrationType,
  data,
  setData,
  modalEvent }) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: 24,
    outline: "none",
    width:{xs:"80vw",md:"50vw"}
  };
  const handleClose = (event) => {

    setOpen(false);

  };



  return (
    <Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Paper sx={style}>
            <Box
              sx={{
                backgroundColor: "primary.main",
                padding: "5px 15px",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  Journal Entries
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: "#fff" }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                padding: "15px",
                height: { xs: "400px", sm: "auto" },
                overflowY: { xs: "scroll", sm: "hidden" },
                ".MuiTableCell-root": {
                  padding: "10px 10px",
                  fontSize: "13px",
                },
              }}
            >
              <JournalEntry
                journalEntry={journalEntry}
                totCdtAmt={totCdtAmt}
                totDbtAmt={totDbtAmt}
                Type={Type}
                invTransArr={invTransArr}
                paymentTransArr={paymentTransArr}
                partyType={partyType}
                registrationType={registrationType}
                modalEvent={modalEvent}
                data={data}
                setData={setData} />
            </Box>
          </Paper>
        </Fade>
      </Modal>
    </Box>
  );
};

export default InvoiceJournalEntryModal;
